<template>
	<div class="helpInfo">
		<div class="content">
			<p class="info-help">常见问题：什么是预加解封？ 什么是直接解封？保费是什么？</p>
			<div class="info-left">
				<h2>常见问题</h2>
				<h3 :class="activeArr[0]?'active':''" @click="haddleTab(0)">保证金含义</h3>
				<h3 :class="activeArr[1]?'active':''" @click="haddleTab(1)">保费含义</h3>
				<h3 :class="activeArr[2]?'active':''" @click="haddleTab(2)">辅助解封账号要求</h3>

				<h2>接单问题</h2>
				<h3 :class="activeArr[3]?'active':''" @click="haddleTab(3)">直接解封流程</h3>
				<h3 :class="activeArr[4]?'active':''" @click="haddleTab(4)">预加解封流程</h3>
				<h3 :class="activeArr[5]?'active':''" @click="haddleTab(5)">中途撤单</h3>
				<h3 :class="activeArr[6]?'active':''" @click="haddleTab(6)">接单者协议</h3>

				<h2>发单问题</h2>
				<h3 :class="activeArr[7]?'active':''" @click="haddleTab(7)">直接解封流程</h3>
				<h3 :class="activeArr[8]?'active':''" @click="haddleTab(8)">预加解封流程</h3>
				<h3 :class="activeArr[9]?'active':''" @click="haddleTab(9)">发单者协议</h3>
			</div>
			<div class="info-right">
				 <el-tabs :class="arr[0]?'eltabs':'eltabs hide'" v-model="activeName1">
					<el-tab-pane label="保证金含义" name="first">
						保证金是对发单者微信号的安全进行一种保障，接单者接手代练前须预缴此金额，当出现接单者原因导致无法解封时，即以此金额赔付给发单者。<br />
						涉及保证金情况<br />
						1、接单者接手预加解封订单后，未在2个小时内扫码进群添加解封微信号<br />
						2、接单者接手预加解封订单被通知解封后，超过24小时未提供解封使用的微信号绑定手机号码<br />
						3、预加解封订单中，发单者说明解封内容后，接单者在24小时内未完成解封内容<br />
						4、接单者接手直接解封订单后，超过2小时未提供解封使用的微信号绑定手机号码<br />
						5、接单者未上传验证原因图（含昵称和ID）和解封成功图<br />
						6、接单者原因撤单终止订单<br />
						以上条款及未尽事宜，代练通官方有最终解释权。
					</el-tab-pane>
					<el-tab-pane label="保费含义" name="second"  >
						保费是给接单者支付的保号费用，预加解封订单超过30天未通知接单者解封的订单将自动支付该费用。
					</el-tab-pane>
					<el-tab-pane label="辅助解封账号要求" name="third"  >
						1、微信号有绑定银行卡且有绑定手机号；<br />
						2、注册时间超过6个月，并且一直有正常登录使用(被封、被冻结的帐号不算有正常使用，用户输入后会提示“ 微信号不存在或者微信号不符合要求，请重新输入”)；<br />
						3、近期没有超过辅助验证次数限制（1次/月、2次/6月、3次/年）；<br />
						4、当前没有被其它人邀请辅助；<br />
						5、最近一年内辅助解封的帐号没有被封过。
					</el-tab-pane>
				</el-tabs>

				<el-tabs :class="arr[1]?'eltabs':'eltabs hide'" v-model="activeName2">
					<el-tab-pane label="直接解封流程" name="first">
						1、在留言信息提供辅助解封的微信号绑定手机号码<br />
						2、根据发单者说明的解封内容解封微信号<br />
						3、操作过程中截图验证原因图（含昵称和ID）和解封成功图 点击查看示例图<br />
						4、解封成功后上传上述截图提交验收
					</el-tab-pane>
					<el-tab-pane label="预加解封流程" name="second"  >
						1、接手订单后立即扫码进群，通过群聊添加解封微信号<br />
						2、出现加好友异常情况立即截图上传，并在留言信息说明不能添加好友的微信号<br />
						3、接手订单2小时后检查添加的微信好友，若有不通过好友验证情况，请立即在留言信息说明未通过验证的微信号<br />
						4、订单被通知解封后，请在留言信息提供辅助解封的微信号绑定手机号码<br />
						5、根据发单者说明的解封内容解封微信号<br />
						6、操作过程中截图验证原因图（含昵称和ID）和解封成功图 点击查看示例图<br />
						7、解封成功后上传上述截图提交验收
					</el-tab-pane>
					<el-tab-pane label="中途撤单" name="third"  >
						什么情况下撤消订单能避免赔偿<br />
						1、接单者提供使用解封微信号绑定手机号码后，发单者超过18小时未回复时<br />
						2、订单信息与实际不符时，例如：订单内的解封微信号与实际解封的微信号不一致时（若信息不符接单者未在第一时间撤单，官方默认下家接受当前订单信息）<br />
						3、发单者允许撤消订单时<br />
						4、保证金为0时
					</el-tab-pane>
					<el-tab-pane label="接单者协议" name="fourth"  >
						协议文本内
					</el-tab-pane>
				</el-tabs>

				<el-tabs :class="arr[2]?'eltabs':'eltabs hide'" v-model="activeName3">
					<el-tab-pane label="直接解封流程" name="first">
						1、接单者接手订单后，根据接单者提供的手机号机进行解封<br />
						2、上传解封内容截图，同时在留言信息说明内容  点击查看示例图<br />
						3、接单者提交验收后检查是否已成功解封<br />
						4、确认验收支付订单金额
					</el-tab-pane>
					<el-tab-pane label="预加解封流程" name="second"  >
					1、在通知解封后，根据接单者提供的手机号机进行解封<br />
					2、上传解封内容截图，同时在留言信息说明内容  点击查看示例图<br />
					3、接单者提交验收后检查是否已成功解封<br />
					4、确认验收支付订单金额
					</el-tab-pane>
					<el-tab-pane label="发单者协议" name="third"  >
						协议文本内
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.helpInfo{background: #f5f5f5;}
	.helpInfo .info-help{ font-size:16px; color:#444444; font-weight: normal; height:60px; line-height: 60px;}
	.helpInfo .info-left{float:left;width:20%; background: #fff;}
	.helpInfo .info-right{float:right;width:73%;background: #fff; padding:20px 2% 30px;font-size:16px;color:#444; line-height: 32px;}
	.helpInfo h2{font-size:18px; color:#444; padding-top:30px; padding-left:30px; padding-bottom: 12px;}
	.helpInfo h3{font-size:16px; color:#666;height:50px; line-height:50px;padding-left:50px; font-weight: normal; cursor: pointer;}
	.helpInfo h3.active{ border-left:solid 2px #5190ff; background: #e3edff; color:#5190ff;} 
	.helpInfo .hide{display: none;}
</style>
<script>   
	export default {
		name: 'helpInfo',
		methods: {
			haddleTab(index){
				for(var i=0;i<this.activeArr.length;i++){
					this.activeArr[i]=false;
				}
				this.$set(this.activeArr, index , true);

				for(var i=0;i<this.arr.length;i++){
					this.arr[i]=false;
				}
				if(index==0){
					this.$set(this.arr, 0 , true);
					this.activeName1='first';
				}else if(index==1){
					this.$set(this.arr, 0 , true);
					this.activeName1='second';
				}else if(index==2){
					this.$set(this.arr, 0 , true);
					this.activeName1='third';
				}else if(index==3){
					this.$set(this.arr, 1 , true);
					this.activeName2='first';
				}else if(index==4){
					this.$set(this.arr, 1 , true);
					this.activeName2='second';
				}else if(index==5){
					this.$set(this.arr, 1 , true);
					this.activeName2='third';
				}else if(index==6){
					this.$set(this.arr, 1 , true);
					this.activeName2='fourth';
				}else if(index==7){
					this.$set(this.arr, 2 , true);
					this.activeName3='first';
				}else if(index==8){
					this.$set(this.arr, 2 , true);
					this.activeName3='second';
				}else if(index==9){
					this.$set(this.arr, 2 , true);
					this.activeName3='third';
				}
			}
		},
		data() {
			return {
				activeName1:'first',
				activeName2:'first',
				activeName3:'first',
				arr:[true,false,false],
				activeArr:[true,false,false,false,false,false,false,false,false,false]
			}
		},
		mounted: function () {
			
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/help.vue